import { ApplicationElement, html } from '@beunity/lit-components';
import CommonActions from '@beunity/lit-components/components/common_actions/element.js';
import '../icon/element.js';
import translations from './translations.js';
import style from './style.lit.css';

/**
 * Holds info about card likes. It is meant to be placed right above the footer.
 *
 * @prop lastPersonLike - Name of the last person to like
 * @prop likeCount - Total number of likes
 * @prop likesUrl - URL of the likes
 */

export default class CardPrefooter extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    lastPersonLike: { type: String },
    likeCount: { type: Number },
    likesUrl: { type: String, reflect: true },
  };

  constructor() {
    super();

    this.likeCount = 0;
    this.addEventListener('click', this);

    /** @internal */
    this.commonActions = new CommonActions(this);
  }

  /** @internal */
  static translations = translations;

  handleEvent(e) {
    if (e.type === 'click') this.handleClick(e);
  }

  handleClick() {
    if (!this.likesUrl) return;

    this.commonActions.execJSFromResponse(this.likesUrl);
  }

  render() {
    return html`
      <span class="icon">
        <bu-icon name="thumbs-up:solid"></bu-icon>
      </span>
      <span>
        ${this.t('liked_by', {
          count: this.likeCount,
          remainingCount: this.likeCount - 1,
          lastPerson: this.lastPersonLike,
        })}
      </span>
    `;
  }
}

CardPrefooter.registerTagName('bu-card-prefooter');

customElements.get('bu-card-prefooter') ||
  customElements.define('bu-card-prefooter', CardPrefooter);
